<template>
  <v-select v-model="country" ref="select" :options="options" label="text"
    @change="(val) => $emit('input', val)"
  ></v-select>
</template>
<script>
import countries from '../../data/countries.js';

export default {
  data () {
    return {
      country: 'US',
    }
  },
  computed: {
    options: () => {
      return countries.getSelectOptions();
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Form/CountrySelect.vue